<template>
  <div class="insights-widget-integration">
    <div>
      <div class="insights-widget-integration-providers">
        <div class="description mb-20">
          <slot name="description" />
        </div>

        <template v-if="token">
          <div
            v-for="(integration, key) in integrations"
            :key="key"
            class="insights-widget-integration-providers-connect"
          >
            <form
              :id="`${widgetKey}_${key}`"
              method="post"
              :action="integration.url"
            >
              <input
                name="authenticity_token"
                type="hidden"
                :value="token"
              />

              <a
                v-tooltip="tooltipOptions"
                v-track:click="widgetClickProperties(key)"
                class="integration-btn cursor-pointer"
                :class="{ disabled: !canSync }"
                :title="tooltip"
                @click.prevent="handleSubmit(key)"
              >
                <img
                  :class="key"
                  :src="integration.src"
                  :alt="integration.alt"
                />

                <div class="text-center">{{ integration.label }}</div>
              </a>
            </form>
          </div>
        </template>
      </div>

      <img
        v-if="showIllustration"
        class="illustration"
        :src="image.src"
        :alt="image.alt"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { INSIGHTS, INSIGHTS_ASSETS as INSIGHTS_IMAGES } from '~/app_constants';
import { InsightsTracking } from '~/mixins';

export default {
  name: 'InsightsWidgetIntegration',
  mixins: [InsightsTracking],
  props: {
    widgetKey: {
      type: String,
      required: true,
    },
    widgetData: {
      type: Object,
      required: true,
    },
    showIllustration: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({ placement: 'top' }),
  }),
  computed: {
    ...mapGetters(['canSeeTeam']),
    token() {
      return document.querySelector('meta[name="csrf-token"]')?.content;
    },
    canSync() {
      return this.canSeeTeam && !!(this.widgetData && this.widgetData[this.integrationURLs]);
    },
    tooltip() {
      return !this.canSync ? 'Only organization owners and managers can set up this integration' : '';
    },
    image() {
      return INSIGHTS_IMAGES[`${this.widgetKey}_connect`];
    },
    integrationURLs() {
      return INSIGHTS[this.widgetKey].integrationUrls;
    },
    integrations() {
      const data = {};

      if (INSIGHTS[this.widgetKey]) {
        for (const key of Object.keys(INSIGHTS[this.widgetKey]?.integrations)) {
          data[key] = {
            ...(INSIGHTS[this.widgetKey]?.integrations && INSIGHTS[this.widgetKey].integrations[key]),
            ...INSIGHTS_IMAGES.integration_logos[key],
            url:
              (this.widgetData &&
                this.widgetData[this.integrationURLs] &&
                this.widgetData[this.integrationURLs][key]) ||
              '#',
          };
        }
      }

      return data;
    },
  },
  methods: {
    widgetClickProperties(key) {
      return {
        label: 'Widget click through',
        widget_name: this.label,
        link_type: `${key} setup button`,
        ...this.commonProps(),
      };
    },
    handleSubmit(key) {
      if (!this.canSync) {
        return false;
      }

      // Small delay to allow the event to be tracked
      setTimeout(() => {
        document.getElementById(`${this.widgetKey}_${key}`).submit();
      }, 250);
    },
  },
};
</script>
